import { RPCDocs, RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Reports/hooks/useReportTypes.ts
var testData = {
	reportTypes: [
		{
			active: true,
			allowedRefs: {},
			category: "Patrol",
			color: "#73d38f",
			description: "Foot patrol description",
			icon: "fingerprint",
			id: "ID_001",
			inputConfigType: RPCDocs.Reports.GetReportTypesList.v1.InputConfigType.MultiEntry,
			name: "Foot Patrol",
			organizationId: "OR_001",
			regionIds: [""]
		},
		{
			active: true,
			allowedRefs: {},
			category: "Patrol",
			color: "#d374c6",
			description: "Car Patrol Description",
			icon: "lightbulb",
			id: "ID_002",
			inputConfigType: RPCDocs.Reports.GetReportTypesList.v1.InputConfigType.MultiEntry,
			name: "Car Patrol",
			organizationId: "OR_002",
			regionIds: [""]
		},
		{
			active: true,
			allowedRefs: {},
			category: "Incident",
			color: "#d3c075",
			description: "Officer Down Description",
			id: "ID_003",
			inputConfigType: RPCDocs.Reports.GetReportTypesList.v1.InputConfigType.SingleEntry,
			name: "Officer Down",
			organizationId: "OR_003",
			regionIds: [""]
		},
		{
			active: true,
			allowedRefs: {},
			category: "Good News",
			description: "Officer Up Description",
			id: "ID_004",
			inputConfigType: RPCDocs.Reports.GetReportTypesList.v1.InputConfigType.SingleEntry,
			name: "Officer Up",
			organizationId: "OR_004",
			regionIds: [""]
		}
	],
	total: 3
};
function useReportTypes(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportTypesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReportTypes };

//# sourceMappingURL=useReportTypes.js.map